/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { Button } from 'react-bootstrap';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';

export default function ClaimDates(props) {
  const { claimDetails } = props;
  return (
    <div>
      <div className="row">
        <div className="col-4">
          <fieldset className="custom-fieldset" style={{ height: '100%' }}>
            <legend className="same-font-family">Claim Dates</legend>
            <div className="form-wrapper">
              <div className="mui-custom-form input-md field-xl">
                <TextField
                  data-testid="WAC_percent"
                  id="date_of_service"
                  label="Date of Service"
                  fullWidth
                  placeholder=""
                  disabled
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ maxLength: 11 }}
                  value={claimDetails?.claimDateVO?.serviceDt || ''}
                />
              </div>
              <div className="mui-custom-form input-md field-xl">
                <TextField
                  data-testid="WAC_percent"
                  id="original_date_paid"
                  label="Original Date Paid:"
                  fullWidth
                  disabled
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ maxLength: 11 }}
                  value={claimDetails?.claimDateVO?.paidDt || ''}
                />
              </div>
              <div className="mui-custom-form input-md field-xl">
                <TextField
                  data-testid="WAC_percent"
                  id="incoming_paid_date"
                  label="Incoming Paid Date:"
                  fullWidth
                  placeholder=""
                  disabled
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ maxLength: 11 }}
                  value={claimDetails?.claimDateVO?.incomingPaidDt || ''}
                />
              </div>
              <div className="mui-custom-form input-md field-xl">
                <TextField
                  data-testid="WAC_percent"
                  id="mco_paid_date"
                  label="MCO Paid Date:"
                  fullWidth
                  placeholder=""
                  disabled
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ maxLength: 11 }}
                  value={claimDetails?.claimDateVO?.mcoPaidDt || ''}
                />
              </div>
              <div className="mui-custom-form input-md field-xl">
                <TextField
                  data-testid="WAC_percent"
                  id="adjudication_date"
                  label="Adjudication Date:"
                  fullWidth
                  placeholder=""
                  disabled
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ maxLength: 11 }}
                  value={claimDetails?.claimDateVO?.adjudicatedDt || ''}
                />
              </div>
            </div>
          </fieldset>
        </div>
        <div className="col-4">
          <fieldset className="custom-fieldset" style={{ height: '100%' }}>
            <legend className="same-font-family">Quarters</legend>
            <div className="form-wrapper">
              <div className="mui-custom-form input-md field-xl">
                <TextField
                  data-testid="WAC_percent"
                  id="paid_quarter"
                  label="Paid Quarter:"
                  fullWidth
                  placeholder=""
                  disabled
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ maxLength: 11 }}
                  value={claimDetails?.quartersVO?.paidQtr || ''}
                />
              </div>
              <div className="mui-custom-form input-md field-xl">
                <TextField
                  data-testid="WAC_percent"
                  id="quarter_processed"
                  label="Quarter Processed:"
                  fullWidth
                  placeholder=""
                  disabled
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ maxLength: 11 }}
                  value={claimDetails?.quartersVO?.dramsQtr || ''}
                />
              </div>
              <div className="mui-custom-form input-md field-xl">
                <TextField
                  data-testid="WAC_percent"
                  id="late_process_quarter"
                  label="Late Process Quarter:"
                  fullWidth
                  placeholder=""
                  disabled
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ maxLength: 11 }}
                  value={claimDetails?.quartersVO?.dramsInvoiceQtr || ''}
                />
              </div>
              <div className="mui-custom-form input-md field-xl">
                <TextField
                  data-testid="WAC_percent"
                  id="supplemental_late_process_quarter"
                  label="Supplemental Late Process Quarter:"
                  fullWidth
                  placeholder=""
                  disabled
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ maxLength: 11 }}
                  value={
                    claimDetails?.quartersVO?.supplementalLateProcessQuarter ||
                    ''
                  }
                />
              </div>
            </div>
          </fieldset>
        </div>
        <div className="col-4">
          <fieldset className="custom-fieldset" style={{ height: '100%' }}>
            <legend className="same-font-family">Internal Dates</legend>
            <div className="form-wrapper">
              <div className="mui-custom-form input-md field-xl">
                <TextField
                  data-testid="WAC_percent"
                  id="claim_load_date"
                  label="Claim Load Date:"
                  fullWidth
                  placeholder=""
                  disabled
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ maxLength: 11 }}
                  value={claimDetails?.internalDateVO?.claimLoadDt || ''}
                />
              </div>
              <div className="mui-custom-form input-md field-xl">
                <TextField
                  data-testid="WAC_percent"
                  id="claim_audit_date"
                  label="Claim Audit Date:"
                  fullWidth
                  placeholder=""
                  disabled
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ maxLength: 11 }}
                  value={claimDetails?.internalDateVO?.auditDt || ''}
                />
              </div>
            </div>
          </fieldset>
        </div>
      </div>
    </div>
  );
}
